export const cards = [
  {
    id: 1,
    title: "страны",
    destinations: [
      "Россия",
      "Тайланд",
      "Черногория",
      "Кипр",
      "Богария",
      "Грузия"
    ]
  },
  {
    id: 2,
    title: "города",
    destinations: [
      "Москва",
      "Санкт-Петербург",
      "Симферополь",
      "Адлер",
      "Екатеринбург",
      "Лондон"
    ]
  },
  {
    id: 3,
    title: "авиакомпании",
    destinations: [
      "Air Berlin",
      "Air France",
      "Alitalia",
      "Air Baltic",
      "Emirates",
      "Turkish Airlines"
    ]
  },
  {
    id: 4,
    title: "аэропорты",
    destinations: [
      "Шереметьево",
      "Курумоч",
      "Гамбург",
      "Домодедово",
      "Толмачево",
      "Рощино"
    ]
  },
  {
    id: 5,
    withoutLink: true,
    title: "направления",
    destinations: [
      "MOW - SIP",
      "MOW - AER",
      "MOV - TIV",
      "MOW - MRV",
      "LED - MOW",
      "MOW - BKK"
    ]
  },
  {
    id: 6,
    withoutLink: true,
    title: "сервисы",
    destinations: [
      "Горящие авиабилеты",
      "Календарь низких цен",
      "Карта низких цен",
      "Спецпредложения",
      "Таблица цен",
      "Блог",
      "Помощь"
    ]
  }
];
